<template>
<div>
  <NavBar/>
  <HomeHeader/>
  <B11/>
  <Roadmap/>
  <Team/>
  <Footer/>
</div>
</template>

<script>
import NavBar from './Navigation/NavBar.vue'
import HomeHeader from './HomeComp/HomeHeader.vue'
import Roadmap from './HomeComp/Roadmap.vue'
import Team from './HomeComp/Team.vue'
import Footer from './Navigation/Footer.vue'
import B11 from './HomeComp/B11.vue'

export default {
  name: "Home",
  components:{
    NavBar,
    HomeHeader,
    Roadmap,
    Team,
    Footer,
    B11
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Home.vue